import aeZqImage from './assets/AE-ZQ/featured.jpg'
import estImage from './assets/EST/featured.jpg'
import iscienceImage from './assets/Iscience/featured.png'
import ncImage from './assets/NC/featured.png'
import nsImage from './assets/NS/featured.png'
import energyRenImage from './assets/Energy-Ren/featured.jpg'
import accreZhangImage from './assets/ACCRE-Zhang/featured.jpg'
import aeHydrogenImage from './assets/AE-Hydrogen/featured.jpg'

export const publications = [
  {
    id: 'AE-ZQ',
    title: "Provincial pathways to carbon-neutral energy systems in China considering interprovincial electricity transmission development",
    authors: ["Qiang Zhang", "Shu Zhang", "Wenying Chen"],
    journal: "Applied Energy",
    year: "2024",
    doi: "https://doi.org/10.1016/j.apenergy.2024.123953",
    type: "期刊论文",
    impact: "SCI",
    image: aeZqImage,
    abstract: "Achieving China's ambitious carbon neutrality goal requires tangible action by the provinces. Significant heterogeneities between provinces make for divergent transition paths and different contributions to climate goals...",
    tags: ["Carbon Neutrality", "Energy Transition", "Interprovincial Electricity Transmission"],
    publishDate: "2024-12",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/8b7692b8264e47ea8c3b/",
  },
  {
    id: 'EST',
    title: "Assessing Representative CCUS Layouts for China's Power Sector toward Carbon Neutrality",
    authors: ["Haotian Tang", "Shu Zhang", "Wenying Chen"],
    journal: "Environmental Science & Technology",
    year: "2021",
    doi: "https://doi.org/10.1021/acs.est.1c03401",
    type: "期刊论文",
    impact: "SCI",
    image: estImage,
    abstract: "China's carbon neutrality target is driving the development of carbon capture, utilization, and storage (CCUS) in the power sector for faster decarbonization...",
    tags: ["CCUS", "Carbon Neutrality"],
    publishDate: "2021-7",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/92c4ac2b185241c3ac85/",
  },
  {
    id: 'Iscience',
    title: "China's Multi-Sector-Shared CCUS Networks in a Carbon-Neutral Vision",
    authors: ["Haotian Tang", "Wenying Chen", "Shu Zhang", "Qianzhi Zhang"],
    journal: "iScience",
    year: "2023",
    doi: "https://doi.org/10.1016/j.isci.2023.106347",
    type: "期刊论文", 
    impact: "SCI",
    image: iscienceImage,
    abstract: "China's carbon-neutral vision necessitates carbon capture, utilization, and storage (CCUS), which is still in its infancy due to inadequate infrastructure and indeterminate technology diffusion. This study proposes China's multi-sector-shared CCUS networks, considering plant-level industrial transfer and infrastructure reuse. Nearly 19,000 km of trunk lines are needed by a capture of 1.74 Gt/yr in 2050.",
    tags: ["Carbon Neutrality", "CCUS"],
    publishDate: "2023-04",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/5dc8b89e53e441d0be99/",
  },
  {
    id: 'NC',
    title: "Assessing the energy transition in China towards carbon neutrality with a probabilistic framework",
    authors: ["Shu Zhang", "Wenying Chen"],
    journal: "Nature Communications",
    year: "2022",
    doi: "https://doi.org/10.1038/s41467-021-27671-0",
    type: "期刊论文",
    impact: "SCI", 
    image: ncImage,
    abstract: "A profound transformation of China's energy system is required to achieve carbon neutrality. This study couples Monte Carlo analysis with a bottom-up energy-environment-economy model to generate 3,000 cases with varying carbon peak times, technological pathways, and cumulative carbon budgets. Results indicate that if emissions peak in 2025, achieving carbon neutrality necessitates a 45–62% electrification rate, 47–78% renewable energy in primary supply, and significant solar and wind power generation, alongside substantial energy storage and negative emissions. The findings emphasize that early peaking is crucial to minimize welfare losses and reliance on carbon removal technologies. Furthermore, technological breakthroughs, changes in production and consumption patterns, and enhanced policies are urgently required to facilitate this transition. The study provides a comprehensive framework for understanding the complex interactions between energy, environment, and economy in the context of China's carbon neutrality goals.",
    tags: ["Energy Transition", "Carbon Neutrality"],
    publishDate: "2022-01",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/6cdcb706a2d5428f8550/",
  },
  {
    id: 'NS',
    title: "Targeting net-zero emissions while advancing other sustainable development goals in China",
    authors: ["Shu Zhang", "Wenying Chen", "Qiang Zhang", "Volker Krey"],
    journal: "Nature Sustainability",
    year: "2024",
    doi: "https://doi.org/10.1038/s41893-024-01400-z",
    type: "期刊论文",
    impact: "SCI", 
    image: nsImage,
    abstract: "The global net-zero transition needed to combat climate change may have profound effects on the energy–food–water–air quality nexus. Accomplishing the net-zero target while addressing other environmental challenges to achieve sustainable development is a policy pursuit for all. Here we develop a multi-model interconnection assessment framework to explore and quantify the co-benefits and trade-offs of climate action for environment-related sustainable development goals in China. We find that China is making progress towards many of the sustainable development goals, but still insufficiently. The net-zero transition leads to substantial sustainability improvements, particularly in energy and water systems. However, the co-benefits alone cannot ensure a sustainable energy–food–water–air quality system. Moreover, uncoordinated policies may exacerbate threats to energy security and food security as variable renewables and bioenergy expand. We urge the implementation of pragmatic measures to increase incentives for demand management, improve food system efficiency, promote advanced irrigation technology and further strengthen air pollutant control measures.",
    tags: ["Net-zero Transition", "Sustainable Development", "Energy-Food-Water-Air Quality Nexus"],
    publishDate: "2024-07",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/dfe8baf782bd4856b070/",
  },
  {
    id: 'Energy-Ren',
    title: "China's Provincial Power Decarbonization Transition in a Carbon Neutral Vision",
    authors: ["Jinhui Ren", "Qianzhi Zhang", "Wenying Chen"],
    journal: "Energy",
    year: "2024",
    doi: "https://doi.org/10.1016/j.energy.2024.133211",
    type: "期刊论文",
    impact: "SCI",
    image: energyRenImage,
    abstract: "The power sector plays a crucial role in achieving the China's carbon neutrality target. However, there remain knowledge gaps regarding provincial emission reduction efforts toward carbon neutrality and the impact of carbon flows embodied in electricity transmissions...",
    tags: ["Power Sector", "Carbon Neutrality", "Electricity Transmission"],
    publishDate: "2024-11",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/d6beb26371824767a23c/",
  },
  {
    id: 'ACCRE-Zhang',
    title: "Analysis of Hydrogen Supply and Demand in China's Energy Transition Towards Carbon Neutrality",
    authors: ["Qian-Zhi Zhang", "Li-Ning Wang", "Wen-Ying Chen", "Cheng-Long Zhang", "Kang-Li Xiang", "Jin-Yu Chen"],
    journal: "Advances in Climate Change Research",
    year: "2024",
    doi: "https://doi.org/10.1016/j.accre.2024.07.013",
    type: "期刊论文",
    impact: "SCI",
    image: accreZhangImage,
    abstract: "The role of hydrogen in the transition to carbon-neutral energy systems will be influenced by key factors such as carbon neutrality pathways, hydrogen production technology costs, and hydrogen transportation costs...",
    tags: ["Hydrogen", "Energy Transition", "Carbon Neutrality"],
    publishDate: "2024-10",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/f26944fb023b4f5b88d6/",
  },
  {
    id: 'AE-Hydrogen',
    title: "Assessing the Impact of Hydrogen Trade Towards Low-Carbon Energy Transition",
    authors: ["Qianzhi Zhang", "Lining Wang", "Wenying Chen", "Chenglong Zhang"],
    journal: "Applied Energy",
    year: "2024",
    doi: "https://doi.org/10.1016/j.apenergy.2024.124233",
    type: "期刊论文",
    impact: "SCI",
    image: aeHydrogenImage,
    abstract: "Hydrogen is increasingly recognized as a pivotal commodity in the low-carbon energy transition, bridging regional disparities in hydrogen production capacity and facilitating international energy trade...",
    tags: ["Hydrogen", "Energy Transition", "Hydrogen Trade", "Energy System"],
    publishDate: "2024-12",
    paperUrl: "https://cloud.tsinghua.edu.cn/f/607fd9f40aef43edbbd7/",
  }
].sort((a, b) => {
  return new Date(b.publishDate) - new Date(a.publishDate);
}); 